import { Input, InputProps } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import formatNumber from "../../utils/helperFunction";

interface Props extends InputProps {
  inputValue?: number | string | undefined;
  onConfirm: (inputValue: string) => void;
  isCurrency?: boolean;
}

export const NumberInput = ({
  onConfirm,
  inputValue,
  isCurrency = true,
  ...rest
}: Props) => {
  const [data, setData] = useState<string>(inputValue?.toString() ?? "");

  useEffect(() => {
    inputValue ? setData(inputValue.toString()) : setData("");
  }, [inputValue]);

  const handleChange = (e: any) => {
    setData(e.target.value);
    onConfirm(removeDots(e.target.value));
  };

  const removeDots = (value: string) => {
    return value.replace(/\./g, "");
  };

  const formattedValue = isCurrency ? formatNumber(data ?? "") : data || "";

  return (
    <Input
      type="text"
      value={formattedValue}
      onChange={handleChange}
      autoComplete="off"
      maxLength={20}
      onKeyDown={(e) => {
        // Allow only numbers, backspace, delete, arrow keys, and tab
        if (
          !/[0-9]/.test(e.key) &&
          e.key !== "Backspace" &&
          e.key !== "Delete" &&
          e.key !== "ArrowLeft" &&
          e.key !== "ArrowRight" &&
          e.key !== "Tab" &&
          e.key !== "Enter"
        ) {
          e.preventDefault();
        }
      }}
      {...rest}
    />
  );
};
